import {
  makeStyles,
  Paper,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";

import { created_by } from "../../../shared-resources/dumpData";

const useStyles = makeStyles((theme) => ({
  headerBox: {
    padding: "0 20px",
  },
  header: {
    minHeight: "40px",
    background: "#4B5558",
    color: "#fff",
    boxShadow: "0px 1px 6px #00000029",
  },
  tablePaper: {
    borderRadius: "12px 0",
    marginTop: "20px",
    padding: "12px",
  },
  dataBox: {
    color: "#343434",
    padding: "0 12px",
  },
  dataItemRow: {
    minHeight: "30px",
    fontSize: "13px",
  },
}));

export default function ResourceManagementComponentsTable({
  data,
  changeComponentsTable,
}) {
  const classes = useStyles();

  const [componentsData, setComponentsData] = useState(data);

  const onChangeEnabled = (i) => {
    const dataChange = JSON.parse(JSON.stringify(componentsData));
    dataChange[i].enabled = !dataChange[i].enabled;
    dataChange[i].modified_by = created_by;
    dataChange[i].modified_date = new Date();
    setComponentsData(dataChange);
    changeComponentsTable(dataChange);
  };

  const onChangeRoles = (i, e) => {
    const dataChange = JSON.parse(JSON.stringify(componentsData));
    dataChange[i].visibility = e.target.value;
    dataChange[i].modified_by = created_by;
    dataChange[i].modified_date = new Date();
    setComponentsData(dataChange);
    changeComponentsTable(dataChange);
  };

  useEffect(() => {
    setComponentsData(data);
  }, [data]);

  return (
    <table className="settingsTable" cellSpacing={0}>
      <thead>
        <tr>
          <td style={{ width: "90%", textAlign: "left" }}>Component</td>
          <td style={{ width: "10%" }}>Enabled</td>
        </tr>
      </thead>
      <tbody>
        {componentsData.map((item, i) => (
          <tr>
            <td>{item.fields}</td>
            <td style={{ textAlign: "center" }}>
              <Checkbox
                className="customCheckBox"
                checked={item.enabled}
                color="primary"
                disabled={item.isenabledfreeze}
                onClick={() => onChangeEnabled(i)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
